@if (contentLoaded) {
    <div class="df" [ngClass]="{'box-shadow' : boxShadow, 'cp' : imageUpload, 'circle-disabled' : disabled}">
        <!-- Circle -->
        <div [class]="'relative-circle circle ' + (!hasImage || loadImgError? '_' + circleBackground : '')"
            [ngClass]="{'grayOut' : grayOut, 'small' : small, 'big' : big, 'medium' : medium}"
            [matTooltip]="this.showTooltip ? this.imageUpload ?  ('Subir nueva imagen') : this.userName : ''">

            @if (hasImage && !loadImgError) {
                <!-- If the user has image -->
                <img [src]="user!.profile_img" (error)="imgError()">
            }
            
            @if (icon) {
                <mat-icon [filled]="false" [style]="'color: var(--t4) !important'">{{icon}}</mat-icon>
            } @else if(!hasImage || loadImgError) {
                <!-- First charater of the user -->
                <span class="singleLetter" [ngClass]="{'me' : isMe && checkIsMe}">
                    {{firstLetter}}
                </span>
            }

            @if (showEditIcon) {
                <mat-icon class="edit-icon" [filled]="true">edit</mat-icon>
            }
            @if (showChangeIcon) {
                <mat-icon class="edit-icon" [filled]="true">change_circle</mat-icon>
            }
        </div>
        @if (showFullName) {
            <!-- By default, the component shows the user full name -->
            <div class="df aic ml5">
                <p class="nmb nametag">{{userName}}</p>
            </div>
        }
        
    </div>
} @else {
    <ng-template #skeleton>
        <app-skeleton class="pen" [circle]="true" [width]="small ? 24 : medium ? 100 : big ? 120 : 32"
            [height]="small ? 24 : medium ? 100 : big ? 120 : 32"></app-skeleton>
    </ng-template>
}




<!--<lib-file-upload style="display: none" [crop]="true" *ngIf="imageUpload"
    (stateChanged)="processNewUpload($event)"></lib-file-upload>-->